import { ConsensusMeterData } from "../types";
import { orderedMeterCategories } from "../utils";
import { CategorySummary } from "./CategorySummary";

interface ResultsSummaryProps {
  consensusMeterResults: ConsensusMeterData | undefined;
  consensusMeterSuccess: boolean;
  isFilteringEnabled: boolean;
  threadInteractionId?: string;
}

export const ResultsSummary = ({
  consensusMeterResults,
  consensusMeterSuccess,
  isFilteringEnabled,
  threadInteractionId,
}: ResultsSummaryProps) => {
  return (
    <>
      <div className="hidden @mobile:flex items-center">
        {orderedMeterCategories.map((category) => (
          <CategorySummary
            key={category}
            isFilteringEnabled={isFilteringEnabled}
            category={category}
            categoryData={consensusMeterResults?.[category] ?? null}
            numResultsAnalyzed={
              consensusMeterResults?.num_results_analyzed ?? 0
            }
            categoryWins={consensusMeterResults?.categoryToWins[category] ?? []}
            consensusMeterSuccess={consensusMeterSuccess}
            display={"flex"}
            includedSeparator={true}
            threadInteractionId={threadInteractionId}
          />
        ))}
      </div>
      <div className="gap-y-1 items-center grid grid-cols-[16px_auto_auto_auto] pb-2 @mobile:hidden">
        {orderedMeterCategories.map((category) => (
          <CategorySummary
            key={category}
            isFilteringEnabled={isFilteringEnabled}
            category={category}
            categoryData={consensusMeterResults?.[category] ?? null}
            numResultsAnalyzed={
              consensusMeterResults?.num_results_analyzed ?? 0
            }
            categoryWins={consensusMeterResults?.categoryToWins[category] ?? []}
            consensusMeterSuccess={consensusMeterSuccess}
            display={"grid"}
            includedSeparator={false}
            threadInteractionId={threadInteractionId}
          />
        ))}
      </div>
    </>
  );
};
